import { render } from "./Tickets.vue?vue&type=template&id=0f2d0398"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"
script.render = render

export default script